export function splitAtUpperCase(str) {
  return str.split(/(?=[A-Z])/);
}

export function getAnalyticsEventsFromNode(node) {
  if (!node.dataset) return [];

  const events = [];

  Object.entries(node.dataset).forEach(([key, value]) => {
    if (!key.startsWith('analytics')) return;

    const keyParts = splitAtUpperCase(key)
      .slice(1)
      .map((part) => part.toLowerCase());
    const [eventType, dataType, ...rest] = keyParts;

    let event = events.find((event) => event.type === eventType);

    if (!event) {
      event = {
        type: eventType,
        name: '',
        params: {},
      };

      events.push(event);
    }

    switch (dataType) {
      case 'event': {
        event.name = value;

        break;
      }

      case 'param': {
        const paramKey = rest.join('_');

        event.params[paramKey] = value;

        break;
      }

      default: {
        throw new Error(`Unknown data type: ${dataType}`);
      }
    }
  });

  return events;
}

export function populateAnalyticsAttributeParams(node, analyticsAttributeParams) {
  const populatedAttributeParams = {};

  Object.entries(analyticsAttributeParams).forEach(([key, value]) => {
    const valueParts = value.split('@');

    if (valueParts.length === 2) {
      populatedAttributeParams[key] = normalizeAnalyticsAttributeParamValue(
        key,
        node[valueParts[1]],
      );
    } else {
      populatedAttributeParams[key] = normalizeAnalyticsAttributeParamValue(key, value);
    }
  });

  return populatedAttributeParams;
}

export function normalizeAnalyticsAttributeParamValue(key, value) {
  if (typeof value !== 'string') return value;

  let normalizedValue = value;
  normalizedValue = normalizedValue.trim();

  // Explicitly convert value to number if the key is `value`. This is required by GA4.
  if (key === 'value') {
    normalizedValue = Number(normalizedValue);
  }

  return normalizedValue;
}
